import React from 'react';

import Container from '../../atoms/Container';
import Footer from '../../molecules/Footer';
import Navbar from '../../molecules/Navbar';
import Card from '../../organisms/CardError';

interface IProps {
  match: { isExact: boolean; params: { id: string }; path: string };
}

const ForgotPassword: React.FC<IProps> = ({ match }: IProps) => {
  const { id } = match.params;
  return (
    <Container>
      <Navbar />
      <Card id={id} />
      <Footer />
    </Container>
  );
};

export default ForgotPassword;
